<template>
    <div>
        <el-upload :action="uploadUrl" :on-remove="handleRemove" :accept="uploadAccept" :multiple="false"
            :show-file-list="false" :file-list="fileList" :before-upload="beforeUpload" :http-request="upload">
            <slot name="btn">上传文件</slot>
        </el-upload>
        <el-dialog append-to-body title="上传进度" :visible="showUploadFile" @close="closeDialog(false)">
            <div class="file">
                <div class="file-list">
                    <p class="file-list-name">文件名称</p>
                    <div style="width:300px">
                        上传进度
                    </div>
                    <!-- <span>{{ file.uploadStatus | fileStatusFilter }}</span> -->
                </div>
                <div class="file-list" v-for="(file, idx) in fileList" :key="idx">
                    <p class="file-list-name">{{ file.name }}</p>
                    <div style="width:300px">
                        <el-progress :percentage="file.percentage" :color="[
                            { color: '#f56c6c', percentage: 20 },
                            { color: '#25A589', percentage: 100 },
                        ]"></el-progress>
                    </div>

                    <!-- <span>{{ file.uploadStatus | fileStatusFilter }}</span> -->
                </div>
                <!-- <div class="file-upload">
          <el-upload
            :action="uploadUrl"
            :on-remove="handleRemove"
            :multiple="false"
            :accept="uploadAccept"
            :show-file-list="false"
            :file-list="fileList"
            :before-upload="beforeUpload"
            :http-request="upload"
          >
            <el-button type="primary">上传文件</el-button>
          </el-upload>
        </div> -->
            </div>
            <span slot="footer" class="dialog-footer" v-if="!autoClose">
                <el-button type="primary" @click="closeDialog(false)">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import * as qiniu from "qiniu-js";
export default {
    props: {
        suffix: {
            type: [Array, String],
            default: []
        },
        // showUploadFile: false,
        openFolderList: {
            type: [Array],
            default: [],
        },
        autoClose: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fileList: [],
            uploadUrl: "",
            showUploadFile: false,
        };
    },
    computed: {
        uploadAccept() {
            return this.suffix.map(one => { return '.' + one }).join(',');
        }
    },
    mounted() { },
    methods: {
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        beforeUpload(file) {
            console.log("before", file, this.showUploadFile);
            let check = this.suffixCheck(file)
            if (check) {
                this.$message.warning(check)
                return false
            }
            if (!this.showUploadFile) { this.showUploadFile = true }
            this.fileList.push({ name: file.name, percentage: 0, uid: file.uid });
        },
        suffixCheck(file) {
            if (!this.suffix.length) { return false }
            let suffix = file.name.split('.').slice(-1)[0].toLowerCase()

            if (typeof this.suffix === 'string' && suffix != this.suffix) {
                return `请选择${this.suffix}类型的文件`
            }

            if (Array.isArray(this.suffix) && !this.suffix.map(one => one.toLowerCase()).includes(suffix)) {
                return `请选择 ${this.suffix.join('、')}类型的文件`
            }
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        upload(file) {
            file = file.file;
            const uid = file.uid;
            const index = this.fileList.findIndex((item) => item.uid == uid);
            let openFolderList = this.openFolderList;

            let data = {
                file_name: file.name,
                file_size: file.size,
                file_type: file.type,
                folder_id: openFolderList.length ? openFolderList.slice(-1)[0].folder_id : null,
            };
            this.$API.getUploadToken(data).then((res) => {
                if (res.code == 0 || res.code == 1000) {

                    this.uploadUrl = res.data.uploadUrl;
                    this.uploadToken = res.data.token;
                    this.baseUrl = res.data.publicDomain;
                    this.key = res.data.key;

                    //file是选择的文件对象
                    return new Promise((resolve, reject) => {
                        let config = {
                            useCdnDomain: true, //表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
                            region: qiniu.region.z0, //选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域。  我这里是华东区
                            // domain: this.uploadUrl, //配置好的七牛云域名  如   https://cdn.qniyun.com/
                            chunkSize: 100, //每个分片的大小，单位mb，默认值3
                            forceDirect: true, //直传还是断点续传方式，true为直传
                        };
                        let putExtra = {
                            fname: file.name, //文件原始文件名
                            params: {},
                            mimeType: [] || null,
                        };
                        let observable = qiniu.upload(
                            file,
                            this.key,
                            this.uploadToken,
                            putExtra,
                            config
                        );
                        observable.subscribe({
                            next: (result) => {
                                //主要用来展示进度
                                this.$set(
                                    this.fileList[index],
                                    "percentage",
                                    parseInt(result.total.percent)
                                );
                                console.log(result, "上传进度", this.fileList[index].percentage);
                            },
                            error: (err) => {
                                //上传错误后触发
                                reject(err);
                                this.$emit("onError", err);
                            },
                            complete: (result) => {
                                //上传成功后触发。包含文件地址。
                                console.log("上传完成", result);
                                resolve(result);
                                this.result = result
                                result.code !== 1000 && this.$message.error(result.message || '文件上传失败')
                                if (this.autoClose) {
                                    this.closeDialog()
                                }
                            },
                        });
                    });
                } else {
                    this.closeDialog(false);
                    this.$message.error(res.message);
                }
            }

            );
        },
        closeDialog(success = true) {
            this.showUploadFile = false
            // this.$emit('update:showUploadFile',false)
            this.fileList.length = 0;

            if (success) {
                console.log(this.result)
                this.$emit("onSuccess", this.result);
            }
        }
    },
};
</script>
<style scoped lang="scss">
.file {
    .file-list {
        display: flex;
        width: 100%;
        padding: 20px;

        .file-list-name {
            width: 200px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
}
</style>